import c from './app-data-table.vue';

export default c;
